import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '@uncinc/react-drupal-core';

import { TIMEZONE } from '../../config/constants';
import Card from '../Card';
import { EventCardProps } from '../Card/types';
import Tag from '../Tag';

import illustrationEvent from '../../assets/images/illustrations/secondary/netwerk.svg';

import './style.scss';

const EventCard: React.FC<EventCardProps> = (props) => {
  const {
    title,
    tags,
    image,
    link,
    startDate = null,
    endDate = null,
    hasMultipleDates = false,
    timezone = TIMEZONE,
    className,
  } = props;

  const { t } = useTranslation();

  const classNames = c('EventCard', 'u-focus-ring--within', 'u-link-box', className);

  return (
    <Card className={classNames}>
      {(tags && tags.length > 0) && (
        <div className="EventCard__tags">
          {tags.map((tag, index) => (
            <Tag
              key={`tag:${tag.type}:${index + 1}`}
              type={tag.type}
              name={tag.name}
            />
          ))}
        </div>
      )}

      <Card.Content>
        <CoreLink href={link}>
          <Card.Title title={title} />
        </CoreLink>

        {(startDate && endDate) && (
          <ul className="EventCard__dates">
            <li>
              {t('components.event_card.date', {
                date: startDate,
                formatParams: {
                  date: {
                    weekday: 'short',
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                    timeZone: timezone,
                  },
                },
              })}
            </li>
            <li>
              {t('components.event_card.time', {
                startDate,
                endDate,
                formatParams: {
                  startDate: {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timezone,
                  },
                  endDate: {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timezone,
                  },
                },
              })}
            </li>
          </ul>
        )}

        {hasMultipleDates && (
          <p className="EventCard__recurring">
            {t('components.event_card.recurring')}
          </p>
        )}
      </Card.Content>

      <Card.Image image={image} fallbackIllustration={illustrationEvent} />
    </Card>
  );
};

export default EventCard;
